import React, { useState } from 'react';
import { useOfflineSync } from '../hooks/useOfflineSync';
import './OfflineIndicator.css';

interface OfflineIndicatorProps {
  className?: string;
}

const OfflineIndicator: React.FC<OfflineIndicatorProps> = ({ className = '' }) => {
  const { isOnline, pendingSync, syncPendingData, hasPendingData } = useOfflineSync();
  const [isMinimized, setIsMinimized] = useState(false);

  const handleSyncClick = () => {
    if (isOnline && hasPendingData) {
      syncPendingData();
    }
  };

  if (isOnline && !hasPendingData) {
    return null; // No mostrar nada cuando está online y no hay datos pendientes
  }

  return (
    <div className={`offline-indicator ${className} ${!isOnline ? 'offline' : 'pending-sync'} ${isMinimized ? 'minimized' : ''}`}>
      <div className="indicator-content">
        {!isOnline ? (
          <>
            <span className="status-icon">📴</span>
            {!isMinimized && <span className="status-text">Sin conexión</span>}
            {!isMinimized && <span className="status-detail">Los datos se guardan localmente</span>}
          </>
        ) : hasPendingData ? (
          <>
            <span className="status-icon">🔄</span>
            {!isMinimized && (
              <span className="status-text">
                {pendingSync.length} registro{pendingSync.length !== 1 ? 's' : ''} pendiente{pendingSync.length !== 1 ? 's' : ''}
              </span>
            )}
            {!isMinimized && (
              <button 
                className="sync-button"
                onClick={handleSyncClick}
                title="Sincronizar ahora"
              >
                Sincronizar
              </button>
            )}
          </>
        ) : null}
        
        <button 
          className="minimize-button"
          onClick={() => setIsMinimized(!isMinimized)}
          title={isMinimized ? "Expandir" : "Minimizar"}
        >
          {isMinimized ? '⬆️' : '⬇️'}
        </button>
      </div>
      
      {hasPendingData && !isMinimized && (
        <div className="pending-list">
          {pendingSync.slice(0, 3).map(item => (
            <div key={item.id} className="pending-item">
              <span className="item-type">
                {item.type === 'headache' ? '🤕' : '💓'}
              </span>
              <span className="item-time">
                {new Date(item.timestamp).toLocaleString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </span>
            </div>
          ))}
          {pendingSync.length > 3 && (
            <div className="more-items">
              +{pendingSync.length - 3} más...
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OfflineIndicator;